<template>
  <main class="main inside-page cabinet-page rooms-page chat-page">
    <div class="section chat-section">
      <div class="wrapper">
        <div class="top">
          <div class="left">
            <div class="desc small purple">
              <b>{{ topic.companion_name }}</b>
            </div>
            <div class="title title-16">{{ topic.title }}</div>
          </div>
          <div class="right">
            <button @click="leaveChat" class="button button-leave">
              {{ topic.is_owner ? $t("Close chat") : $t("Leave chat") }}
            </button>
            <div
              v-if="participantsCount >= 2"
              class="button-settings-container"
            >
              <button class="button button-settings">
                {{ $t("Settings") }}
              </button>
              <div class="button-settings-dropdown">
                <div class="button-settings-dropdown-wrapper">
                  <button
                    v-if="!topic.is_owner"
                    class="desc"
                    @click="
                      reportType = 'topic';
                      showReportModal = true;
                    "
                  >
                    {{ $t("Report topic") }}
                  </button>
                  <button
                    class="desc"
                    @click="
                      reportType = 'user';
                      showReportModal = true;
                    "
                  >
                    {{ $t("Report user") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="chat-container is-downloaded-images">
          <div class="chat">
            <div class="chat-top">
              <div class="user-main">
                <img class="userNameBg" src="../assets/userNameBg.png" />
                <img class="userNameBg mob" src="../assets/userNameBgMob.svg" />
                <div v-if="topic.id" class="desc">
                  {{ topic.companion_name }}
                </div>
              </div>
              <div v-if="participantsCount >= 2" class="online">
                <img class="online-img" src="../assets/online.svg" />
                <div class="desc desc-online">{{ $t("online") }}</div>
              </div>
            </div>
            <div class="chat-content">
              <div
                @scroll="handleScroll"
                ref="messages"
                class="chat-content-wrapper"
              >
                <div class="list">
                  <MessageItem
                    v-for="message in messages"
                    :key="`${message.id}${message.is_typing}`"
                    :message="message"
                    @open-file="openOrDownloadFile"
                    @preview-image="imagePreview"
                  />
                </div>
              </div>
            </div>
            <ValidationObserver
              slim
              v-slot="{ invalid, pristine, handleSubmit }"
            >
              <form
                ref="form"
                @submit.prevent="handleSubmit(sendMessage)"
                class="chat-bottom"
              >
                <div class="message-area">
                  <div class="left">
                    <ValidationProvider rules="" slim vid="message">
                      <label>
                        <textarea
                          @keydown.enter.prevent="handleSubmit(sendMessage)"
                          :disabled="participantsCount < 2"
                          v-model="message"
                          name="message"
                          class="desc"
                          type="text"
                          :placeholder="
                            participantsCount >= 2
                              ? $t('Write your message...')
                              : $t(
                                  'Waiting for the other person join this chat'
                                )
                          "
                        />
                      </label>
                    </ValidationProvider>
                  </div>
                  <div class="right">
                    <button
                      class="button colored"
                      @click="submit(!isAllowedToSendMessage)"
                      :class="{ disabled: !isAllowedToSendMessage }"
                    >
                      <span>{{ $t("Send") }}</span>
                      <img class="img" src="../images/enter.svg" />
                      <button
                        :disabled="!isAllowedToSendMessage"
                        ref="submitMessage"
                        type="submit"
                        style="display: none"
                      ></button>
                    </button>
                  </div>
                </div>
                <div class="chat-info">
                  <div class="left">
                    <div class="amount-container">
                      <div class="amount">
                        <div class="desc desc-12">
                          {{ $t("Current balance") }}:
                        </div>
                        <div class="desc small">
                          <b>{{ balance }}</b>
                          <img class="coin" src="../images/coin.svg" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="right">
                    <label class="sticker">
                      <StickerMenu
                          v-if="topic.id"
                          :companion-name="topic.companion_name"
                          :topic-id="topic.id"
                      />
                    </label>
                    <label class="camera">
                      <input
                        :disabled="participantsCount < 2"
                        accept="image/*"
                        @change="uploadFile('imageFile')"
                        ref="imageFile"
                        type="file"
                      />
                      <img class="img" src="../images/camera.svg" />
                    </label>
                    <label class="clip">
                      <input
                        :disabled="participantsCount < 2"
                        @change="uploadFile('documentFile')"
                        ref="documentFile"
                        type="file"
                      />
                      <img class="img" src="../images/clip.svg" />
                    </label>
                  </div>
                </div>
                <div
                  class="downloaded-images"
                  v-if="documentFileData || imageFileData"
                >
                  <div class="downloaded-images-wrapper">
                    <div
                      v-if="documentFileData"
                      class="downloaded-images__item"
                    >
                      <img
                        @click="openOrDownloadFile(documentFileData.link)"
                        class="img"
                        src="../assets/file.svg"
                      />
                      <div class="text">
                        <div class="desc">{{ documentFileData.name }}</div>
                        <img
                          @click="clearFile('documentFile')"
                          class="bin"
                          src="../images/bin.svg"
                        />
                      </div>
                    </div>
                    <div v-if="imageFileData" class="downloaded-images__item">
                      <img
                        class="img"
                        @click="imagePreview(imageFileData.link)"
                        :src="imageFileData.link"
                      />
                      <div class="text">
                        <div class="desc">{{ imageFileData.name }}</div>
                        <img
                          @click="clearFile('imageFile')"
                          class="bin"
                          src="../images/bin.svg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <ReportModal
        @apply="sendReport"
        @close="showReportModal = false"
        v-if="showReportModal"
      />
    </transition>
    <vue-easy-lightbox
      :visible="imagePreviewVisible"
      :imgs="images"
      :index="index"
      @hide="hideImagePreview"
    ></vue-easy-lightbox>
  </main>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import axios from "@/axios";
import router from "@/router";
import { humanFileSize } from "@/utils";
import ReportModal from "@/components/ReportModal.vue";
import StickerMenu from "@/components/stickers/StickerMenu.vue";
import MessageItem from "@/components/MessageItem.vue";
import VueEasyLightbox from "vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min.js";
import "vue-easy-lightbox/dist/external-css/vue-easy-lightbox.css";

export default {
  name: "Chat", 
  props: ["chatNoteModalIsVisible"],
  components: {
    ValidationProvider,
    ValidationObserver,
    ReportModal,
    VueEasyLightbox,
    StickerMenu,
    MessageItem,
  },
  data: function () {
    return {
      intervalId: null,
      participantsIntervalId: null,
      message: "",
      messages: [],
      page: 1,
      pageSize: 25,
      lastPage: null,
      topic: {},
      loadingMessages: false,
      documentFile: null,
      imageFile: null,
      documentFileData: null,
      imageFileData: null,
      showReportModal: false,
      reportType: null,
      imagePreviewVisible: false,
      images: [],
      index: 0,
    };
  },
  async created() {
    const self = this;

    // const messages = this.getMessages().then(({data}) => {
    //   if (data.status === 'OK') {
    //     self.messages = data.payload.data;
    //     self.lastPage = data.payload.meta.last_page;
    //   }
    // });

    // await Promise.all([this.getTopic(), this.newMessages()])

    await this.getTopic();

    if (self.participantsCount < 2) {
      self.setUpParticipantsPooling();
    }

    if (!this.isCurrentChatAgreed) {
      this.$parent.openChatNoteModal(this.topic.id);
    } else {
      await this.newMessages();
      this.setUpNewMessagePooling();
    }

    // const newMessages = this.newMessages();

    // await newMessages;
  },
  // mounted() {
  //   this.$parent.openChatNoteModal();
  // },
  beforeDestroy() {
    this.clearMessagePooling();
    this.clearParticipantsPooling();
  },
  unmounted() {
    this.clearMessagePooling();
    this.clearParticipantsPooling();
  },
  methods: {
    scrollToEnd() {
      const scrollableDiv = this.$refs.messages;
      scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
    },
    imagePreview(src) {
      this.images = [src];
      this.imagePreviewVisible = true;
    },
    hideImagePreview() {
      this.imagePreviewVisible = false;
    },
    sendReport() {
      const self = this;

      axios
        .post("reports/create", {
          topic_id: self.topic.id,
          type: self.reportType,
        })
        .then(async ({ data }) => {
          if (data.status === "OK") {
            self.showNotification({
              text: this.$t(
                "Your report has been successfully sent. Our team will review this report shortly"
              ),
            });
            await router.push({
              name: "Topics",
              params: { name: this.$route.params.name },
            });
          }
        })
        .finally(() => {
          self.showReportModal = false;
        });

      //     .then(({data}) => {
      //   if (data.status === 'OK') {}
      // })
    },
    humanFileSize,
    openOrDownloadFile(path) {
      // Attempt to open the file in a new window
      const newWindow = window.open(path, "_blank");

      // Check if the new window is opened
      if (newWindow) {
        // Focus the new window
        newWindow.focus();
      } else {
        // If the browser blocks opening the new window, download the file in the current window
        this.downloadFileInCurrentWindow(path);
      }
    },
    downloadFileInCurrentWindow(fileUrl) {
      // Create a temporary link element
      const link = document.createElement("a");
      link.href = fileUrl;

      // Simulate clicking the link to trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up after download
      document.body.removeChild(link);
    },
    
    uploadFile(type) {
      console.log(type, this.$refs[type]);
      const file = this.$refs[type].files[0];
      console.log(file, "file");
      this.$data[type] = file;
      this.$data[`${type}Data`] = {
        link: window.URL.createObjectURL(file),
        name: file.name,
        fileSize: humanFileSize(file.size),
      };
    },
    clearFile(type) {
      this.$data[type] = null;
      this.$data[`${type}Data`] = null;
    },
    async goToTopics() {
      await router.push({
        name: "Topics",
        params: { name: this.$route.params.name },
      });
    },
    leaveChat() {
      const self = this;

      axios
        .post("topics/leave", {
          topic_id: self.topic.id,
        })
        .then(({ data }) => {
          if (data.status === "OK") {
            self.clearMessagePooling();
            self.clearParticipantsPooling();
            self.goToTopics();
          }
        });
    },
    setUpNewMessagePooling() {
      clearInterval(this.intervalId);
      const self = this;

      this.intervalId = setInterval(() => {
        if (!self.loadingMessages) {
          self.newMessages();
        }
      }, 5000);
    },
    setUpParticipantsPooling() {
      clearInterval(this.participantsIntervalId);
      const self = this;

      this.participantsIntervalId = setInterval(async () => {
        if (self.participantsCount < 2) {
          await self.getTopic();
        } else {
          self.clearParticipantsPooling();
        }
      }, 5000);
    },
    clearParticipantsPooling() {
      clearInterval(this.participantsIntervalId);
    },
    clearMessagePooling() {
      clearInterval(this.intervalId);
    },
    getTopic() {
      const self = this;
      const slug = this.$route.params.slug;
      
      if (!slug || slug === 'null' || slug === 'undefined') {
        self.goToTopics();
        return Promise.resolve();
      }
      
      return axios
        .get("topics/topic", {
          params: {
            slug: slug,
          },
        })
        .then(({ data }) => {
          if (data.status === "OK") {
            self.topic = data.payload;
            setTimeout(function () {
              self.scrollToEnd();
            }, 300);
          }
        })
        .catch(({ response }) => {
          if (response.status === 404 || response.status === 400) {
            self.goToTopics();
          }
        });
    },
    submit(disabled) {
      if (!disabled) {
        try {
          this.$refs.form.$el.submit();
          // eslint-disable-next-line no-empty
        } catch (e) {}
      }
    },
    async sendMessage() {
      const self = this;
      this.clearMessagePooling();

      const formData = new FormData();
      formData.set("topic_id", this.topic.id);
      formData.set("content", this.message);

      if (this.documentFile) {
        formData.append("attachments[]", this.documentFile);
        formData.append("types[]", "document");
      }

      if (this.imageFile) {
        formData.append("attachments[]", this.imageFile);
        formData.append("types[]", "image");
      }

      await axios
        .post("messages/create", formData)
        .then(({ data }) => {
          if (data.status === "OK") {
            self.clearChatInputs();
            const message = data.payload.message;

            if (!self.messages.some(({ id }) => id === message.id)) {
              self.messages = [...self.messages, message];
            }

            self.SET_BALANCE(data.payload.balance);
            setTimeout(() => {
              self.scrollToEnd();
            }, 100);
          }
        })
        .catch(({ response }) => {
          if (response.status === 402) {
            self.showNotification({ text: response.data.message, ok: true });
          }
        })
        .finally(() => {
          self.newMessages();
          self.setUpNewMessagePooling();
        });
    },
    clearChatInputs() {
      this.message = "";
      this.imageFile = null;
      this.documentFile = null;
      this.imageFileData = null;
      this.documentFileData = null;
    },
    async getMessages(page = null, pageSize = null) {
      const data = [
        "messages/index",
        {
          params: {
            topic_id: this.topic.id,
            order_by: "id",
            page_size: pageSize || this.pageSize,
            page: page || this.page,
          },
        },
      ];

      return axios.get(...data);
    },
    async newMessages(pageSize = null) {
      const self = this;
      this.loadingMessages = true;

      return this.getMessages(1, pageSize)
        .then(({ data }) => {
          if (data.status === "OK") {
            const updatedMessages = [...self.messages];
            let newMessagesAdded = false;

            data.payload.data.forEach((newMessage) => {
              const existingIndex = updatedMessages.findIndex(
                (m) => m.id === newMessage.id
              );

              if (existingIndex >= 0) {
                // Обновляем существующее сообщение
                updatedMessages[existingIndex] = newMessage;
              } else {
                // Добавляем новое сообщение в начало массива
                updatedMessages.unshift(newMessage);
                newMessagesAdded = true; // Пометка что добавились новые сообщения
              }
            });

            // Sort all messages by ID to ensure they are in chronological order.
            updatedMessages.sort((a, b) => a.id - b.id);

            self.messages = updatedMessages;
            self.lastPage = data.payload.meta.last_page;

            // Если есть новые сообщения — скроллим вниз
            if (newMessagesAdded) {
              setTimeout(() => {
                self.scrollToEnd();
              }, 100);
            }
          }
        })
        .catch(async ({ response }) => {
          if (response.status === 404) {
            const payload = response.data.payload;

            if (payload && payload.closed) {
              self.clearMessagePooling();
              self.clearParticipantsPooling();
              self.$parent.closeChatNoteModal();
              self.goToTopics();
              await self.showNotification({ text: response.data.message });
            }
          }
        })
        .finally(() => {
          self.loadingMessages = false;
        });
    },
    async handleScroll() {
      const self = this;
      const messagesEl = this.$refs.messages;
      // Load more messages when scrolled to the top
      if (
        messagesEl.scrollTop === 0 &&
        this.page < this.lastPage &&
        !this.loadingMessages
      ) {
        this.loadingMessages = true;
        this.page++;
        const oldScrollHeight = messagesEl.scrollHeight;
        await this.getMessages()
          .then(({ data }) => {
            if (data.status === "OK") {
              // Prepend older messages. API returns newest first for the page, so reverse them.
              const olderMessages = data.payload.data.slice().reverse();
              self.messages = [...olderMessages, ...self.messages];
              self.lastPage = data.payload.meta.last_page;
              self.$nextTick(() => {
                messagesEl.scrollTop =
                  messagesEl.scrollHeight - oldScrollHeight;
              });
            }
          })
          .catch(async ({ response }) => {
            if (response.status === 404) {
              const payload = response.data.payload;

              if (payload && payload.closed) {
                self.clearMessagePooling();
                self.clearParticipantsPooling();
                self.$parent.closeChatNoteModal();
                self.goToTopics();
                await self.showNotification({ text: response.data.message });
              }
            }
          })
          .finally(() => {
            self.loadingMessages = false;
          });
      }
    },
    
    ...mapActions("app", ["showNotification"]),
    ...mapMutations("user", ["SET_BALANCE"]),
  },
  computed: {
    isAllowedToSendMessage() {
      return (
        this.participantsCount >= 2 &&
        (this.documentFile || this.imageFile || this.message)
      );
    },
    isCurrentChatAgreed() {
      return this.isChatAgreed(this.topic.id);
    },
    participantsCount() {
      if (this.topic) {
        return this.topic.participants_count;
      }

      return 0;
    },
    ...mapGetters("user", ["balance"]),
    ...mapGetters("topics", ["topicId"]),
    ...mapGetters("topics", ["chatAgreed", "isChatAgreed"]),
  },
  watch: {
    chatNoteModalIsVisible(newValue) {
      if (!newValue) {
        this.newMessages();
        this.setUpNewMessagePooling();
      }
    },
  },
};
</script>